export class ExpectedError extends Error {
  constructor(message?: string, context?: string) {
    super(message);
    // eslint-disable-next-line no-console
    console.info(`[${context ?? this.name ?? 'N/A'}] ${message}`);
  }
}
